import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import { CookieConsentProvider } from "@/context/CookieConsent";
import SmoothScroll from "@/components/SmoothScroll";
import Layout from "@/components/Layout";
import CookieBanner from "@/components/CookieBanner";
import Home from "@/pages/Home";
import Courtage from "@/pages/Courtage";
import Conseil from "@/pages/Conseil";
import APropos from "@/pages/APropos";
import Contact from "@/pages/Contact";
import MentionsLegales from "@/pages/MentionsLegales";
import CookiePolicy from "@/pages/CookiePolicy";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
      <Route
        path="/*"
        element={
          <SmoothScroll>
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/courtage" element={<Courtage />} />
                <Route path="/conseil" element={<Conseil />} />
                <Route path="/a-propos" element={<APropos />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/mentions-legales" element={<MentionsLegales />} />
                <Route path="/politique-cookies" element={<CookiePolicy />} />
              </Routes>
            </Layout>
            <CookieBanner />
          </SmoothScroll>
        }
      />
    </Routes>
  );
}

export default function App() {
  return (
    <AppProvider>
      <CookieConsentProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </CookieConsentProvider>
    </AppProvider>
  );
}
